export default "__VITE_ASSET__$bG2CpPi__"